import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { RoleAccessService } from '../../shared/services/role-access.service';
import { RoutePath } from '../../shared/enums/common.enum';

const normalizeRequiredRoles = (route: ActivatedRouteSnapshot): string[] => {
  const data = route.data || {};
  const required = data['requiredRoles'] ?? data['requiredRole'] ?? data['role'] ?? [];
  if (Array.isArray(required)) return required;
  if (typeof required === 'string') return [required];
  return [];
};

/**
 * Role Guard - restricts sub-admin routes to delegated roles
 */
export const roleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean => {
  const router = inject(Router);
  const roleAccessService = inject(RoleAccessService);

  if (!roleAccessService.isSubAdmin()) {
    return true;
  }

  const activeRoles = roleAccessService.getActiveRoleIds();
  const requestedUrl = state.url || '';
  const isDashboard = requestedUrl.startsWith(`/${RoutePath.DASHBOARD}`);

  if (activeRoles.length === 0 && !isDashboard) {
    router.navigate([`/${RoutePath.DASHBOARD}`]);
    return false;
  }

  const requiredRoles = normalizeRequiredRoles(route);
  if (requiredRoles.length === 0) {
    return true;
  }

  const hasAccess = requiredRoles.some(role => activeRoles.includes(role));
  if (!hasAccess && !isDashboard) {
    router.navigate([`/${RoutePath.DASHBOARD}`]);
    return false;
  }

  return hasAccess || isDashboard;
};
